module.exports = __webpack_public_path__ + "media/images/help/faq-fav-pc-cf0ed3314e3f5d2d13a49a6225938112.jpg";